<template>
  <v-card :disabled="loading" flat class="pa-5">
    <v-progress-linear
      indeterminate
      v-if="loading"
      class="my-2"
      color="primary"
    ></v-progress-linear>
    <v-col
      cols="12"
      v-for="(gate, i) in gates"
      :key="i"
      style="padding: 0"
      class="my-2"
    >
      <v-card
        @click="addGate(gate)"
        :elevation="gateModel.find((item) => item.id == gate.id) ? 2 : 0"
        :color="gateModel.find((item) => item.id == gate.id) ? '#eaeaea' : null"
        rounded="xl"
        height="80px"
        class="d-flex pa-2 justify-space-around align-items-center border cursor-pointer"
        :ripple="false"
      >
        <v-avatar>
          <!-- <v-icon>{{ gate.icon }}</v-icon> -->
          <v-img :src="gate.icon" size="50px"></v-img>
        </v-avatar>
        <v-card-text>
          <v-card-title tag="h1" color="black">
            <h4 style="color: #32325a">{{ gate.title }}</h4>
          </v-card-title>
          <v-card-subtitle style="color: #32325a">{{
            gate.subtitle
          }}</v-card-subtitle>
        </v-card-text>
        <v-card-actions>
          <v-card-text
            class="d-flex"
            v-if="gateModel.find((item) => item.id == gate.id)"
          >
            <v-icon color="green"> mdi-check-circle-outline </v-icon>
          </v-card-text>
          <v-card-text class="d-flex" v-else>
            <v-icon color="gray"> mdi-plus-circle </v-icon>
          </v-card-text>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-card>
</template>

<script>
export default {
  props: { value: Array, qr_id: [Number, String] },
  name: "selectGate",
  data() {
    return {
      gates: [],
      loading: false,
    };
  },

  computed: {
    gateModel: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  mounted() {
    this.fetch();
  },

  methods: {
    addGate(gate) {
      // const find = this.gateModel.find((item) => item.id == gate.id);
      // if (find) {
      //   this.gateModel = this.gateModel.filter((item) => item.id !== gate.id);
      //   this.$toast.info("درگاه پرداخت با موفقیت حذف شد");
      // } else {
      //   this.gateModel.push(gate);
      //   this.$toast.success("درگاه پرداخت با موفقیت اضافه شد");
      // }
      console.log(this.qr_id,"qr_iidd jhree  96 +");
      this.loading = true;
      this.$api
        .post(`/v1/gate-way/qr/${gate.id}/${this.qr_id}`)
        .then((data) => {
          this.loading = false;
          this.$toast.success("درگاه پرداخت با موفقیت اضافه شد");
          this.$emit("fetch");
        })
        .catch((err) => {
          this.loading = false;
          this.$toast.error("مشکلی پیش آمده است");
        });
    },
    fetch() {
      this.loading = true;
      this.$api.get(`/v1/gate-way`).then(({ data }) => {
        this.gates = data.data;
        this.loading = false;
      });
    },
  },
};
</script>

<style scoped>
.v-card:active {
  box-shadow: none !important;
}
</style>
